import { getFirestore, doc, collection, query, where, getDoc, getDocs, setDoc, onSnapshot, deleteDoc, updateDoc, deleteField } from "firebase/firestore"
import { removeExtensionsFromBoosters } from "@/assets/functions/assetCleanup.js"

const db = getFirestore()
const collectionName = "extensions"

function docToInstance(document) {
  const data = document.data()
  return data ? new Extension(document.id, data.name, data.collection, data.color, data.isPublic) : null
}

class Extension {
  constructor(id, name, collection, color, isPublic = true) {
    this.id = id
    this.name = name
    this.collection = collection
    this.color = color || "#9E9E9E"
    this.isPublic = isPublic !== false
  }

  static initOne(name = "") {
    const id = Extension.createId(name)
    return new Extension(id, name, "", "#9E9E9E", true)
  }

  static createId(name) {
    return name
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .replace(/ /g, "-")
      .toLowerCase()
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "")
  }

  static async getAll() {
    const documents = await getDocs(collection(db, collectionName))
    return documents.docs.map(docToInstance)
  }

  static async getById(id) {
    const document = await getDoc(doc(db, collectionName, id))
    return docToInstance(document)
  }

  static async getByCollection(collectionId) {
    const q = query(collection(db, collectionName), where("collection", "==", collectionId))
    const documents = await getDocs(q)
    return documents.docs.map(docToInstance)
  }

  static async listenAll(callback) {
    return onSnapshot(collection(db, collectionName), (snapshot) => {
      const list = []
      snapshot.forEach((d) => list.push(docToInstance(d)))
      callback(list)
    })
  }

  async save() {
    const newDoc = {
      name: this.name,
      collection: this.collection,
      color: this.color || "#9E9E9E",
      isPublic: this.isPublic !== false,
    }

    if (this.id) {
      await setDoc(doc(db, collectionName, this.id), newDoc)
    } else {
      this.id = Extension.createId(this.name)
      await setDoc(doc(db, collectionName, this.id), newDoc)
    }
    return true
  }

  async delete() {
    if (this.id) {
      const cardsQuery = query(collection(db, "cards"), where("extension", "==", this.id))
      const cardsSnapshot = await getDocs(cardsQuery)
      const updates = cardsSnapshot.docs.map((cardDoc) => updateDoc(cardDoc.ref, { extension: deleteField() }))
      await Promise.all(updates)

      // Cascade : retire l'extension des boosters qui la ciblent.
      await removeExtensionsFromBoosters([this.id])

      await deleteDoc(doc(db, collectionName, this.id))
    }
    return true
  }
}

export default Extension
